import { BoostRewardsIndicator } from "./BoostRewardsIndicator/BoostRewardsIndicator";
import { useEffect, useMemo, useState } from "react";
import { ExpeditionHireEmployeesModal } from "../../ExpeditionHireEmployeesModal/ExpeditionHireEmployeesModal";
import { useModalStore } from "../../../../../Store/ModalStore";
import styles from "../../ExpeditionDetails/ExpeditionDetails.module.css";
import star from "/tgstar.svg";
import infoCircle from "/Expeditions/info-circle.svg";
import briefcase from "/Expeditions/briefcase.svg";
import { Expedition } from "../../../types";
import { ExpeditionStatusBar } from "./ExpeditionStatusBar/ExpeditionStatusBar";
import { useNotificationStore } from "../../../../../Store/NotificationStore";
import {
	getExpeditionInfo,
	getInvoice,
} from "../../../../../Services/Requests";
import { Loader } from "../../../../../Components/Loader/Loader";
import { InfoTip } from "../../../../../Components/InfoTip/InfoTip";
import { useTimeDisplay } from "../../../../../../utils/TimeDisplay";
import { useParseTimeToSeconds } from "../../../hooks/useParseTimeToSeconds";
import { BoostTip } from "./BoostTip/BoostTip";

interface ActiveExpeditionInfoProps {
	expedition: Expedition;
	setExpedition: React.Dispatch<React.SetStateAction<Expedition | null>>;
}

const ActiveExpeditionInfo: React.FC<ActiveExpeditionInfoProps> = ({
	expedition,
	setExpedition,
}) => {
	const [progress, setProgress] = useState<number | null>(null);
	const [expeditionIsDone, setExpeditionIsDone] = useState(false);
	const [statusBarMounted, setStatusBarMounted] = useState(false);
	const [employeesCount, setEmployeesCount] = useState(5);
	const [activeTab, setActiveTab] = useState<null | 3 | 5 | 10>(5);
	const [loading, setLoading] = useState(false);

	const setNotification = useNotificationStore(state => state.setNotification);
	const handleClose = useModalStore(state => state.handleClose);
	const open = useModalStore(state => state.open);

	const setOpen = useModalStore(state => state.setOpen);

	const { timeLeft } = useTimeDisplay(expedition?.user_metadata?.ended_at);

	const handleStartExpedition = async () => {
		return new Promise(resolve => {
			setTimeout(async () => {
				try {
					//@ts-ignore
					const data = await getExpeditionInfo(expedition?.id);

					setExpedition(data);

					setLoading(false);
					resolve(true);
				} catch (error) {
					setNotification({
						type: "Error",
						message:
							"Ошибка при начале экспедиции. Попробуйте позже. Все ваши награды будут сохранены",
					});
					resolve(null);
				}
			}, 5000);
		});
	};

	const handlePurchaseEmployees = async (amount: number, id: number) => {
		try {
			console.log("invoice", {
				title: "Покупка рабочих для экспедиции",
				description: "Buy Employees for the Expedition",
				amount: amount,
				id: Number(id),
				item_type: "expedition",
				details: {
					charges: amount,
				},
			});

			const invoice = await getInvoice({
				title: "Покупка рабочих для экспедиции",
				description: "Buy Employees for the Expedition",
				amount: amount,
				id: Number(id),
				item_type: "expedition",
				details: {
					charges: amount,
				},
			});
			console.log("Инвойс получен", invoice);

					const tg = window.Telegram?.WebApp;
					tg.openInvoice(invoice.invoice_link, async (status: string) => {
						console.log("Статус оплаты", status);
						if (status === "paid") {
							setLoading(true);
							setNotification({
								type: "Success",
								message: "Оплата прошла успешно!",
							});

							handleStartExpedition();

							setTimeout(() => {
								handleClose();
							}, 700);
						} else if (status === "failed") {
							console.log("Подождите...", status);
							setNotification({
								type: "Success",
								message: "Подождите...",
							});

							handleClose();
						}
					});
				} catch (error) {
					console.error("Ошибка при покупке купонов:", error);
					setNotification({
						type: "Error",
						message: "Произошла ошибка при покупке рабочих",
					});
				}
			};

			const formatNumberWithCommas = useMemo(() => {
				return (num: number | undefined): string => {
					if (num !== undefined && num !== null) {
						return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
					}
					return "";
				};
			}, [expedition]);

			useEffect(() => {
				if (useParseTimeToSeconds(timeLeft as string) > 0) {
					setStatusBarMounted(true);
				}
			}, [timeLeft]);

			return (
				<>
					<div className={styles.rulesContainer}>
						<div className={styles.leftPart}>
							<div className={styles.cost}>
								<p>{expedition?.config?.entry_fee_amount}</p>
								<img width={16} height={16} src={star} alt='Telegram star' />
							</div>
							<p className={styles.costDescription}>
								Стоимость <br /> рабочей смены
							</p>
						</div>
						<div className={styles.rightPart}>
							<div className={styles.workShiftsCount}>
								<p>
									{expedition?.used_charges}/
									{formatNumberWithCommas(expedition?.max_charges)}
								</p>
								<img width={16} height={16} src={briefcase} alt='Briefcase' />
							</div>
							<p className={styles.workShiftsCountDescription}>
								Количество <br /> рабочих смен
							</p>
						</div>
					</div>

					<div className={styles.boostContainer}>
						<div className={styles.boostDescription}>
							<div className={styles.boostLeftPart}>
								<p>Буст наград</p>

								<div className={styles.boostTips}>
									<InfoTip
										image={
											<img
												src={infoCircle}
												alt='Info'
												style={{ display: "block" }}
											/>
										}
										style={{ transform: "translateX(45%)" }}
									>
										<BoostTip />
									</InfoTip>
								</div>
							</div>

							<span className={styles.boostRightPart}>
								{expedition?.user_metadata?.all_charges}/
								{expedition?.required_limit_for_bonus} работников
							</span>
						</div>

						<BoostRewardsIndicator
							expedition={expedition}
							employeesCount={employeesCount}
						/>
					</div>

					<div className={styles.buttonsContainer}>
						{loading || !expedition ? (
							<Loader size='small' containerStyle={{ padding: "0" }} />
						) : expedition?.user_metadata?.status === "IN_PROGRESS" &&
							statusBarMounted ? (
							<ExpeditionStatusBar
								expedition={expedition}
								progress={progress}
								expeditionIsDone={expeditionIsDone}
								setExpedition={setExpedition}
								setProgress={setProgress}
								setExpeditionIsDone={setExpeditionIsDone}
								setLoading={setLoading}
							/>
						) : expedition?.user_metadata?.status === "OPEN" ? (
							<button className={styles.button} onClick={() => setOpen(true)}>
								<span>Нанять работников</span>
								<img src={star} alt='Telegram star' />
							</button>
						) : (
							""
						)}
					</div>

					{open &&
						expedition &&
						(() => {
							return (
								<ExpeditionHireEmployeesModal
									employeesCount={employeesCount}
									setEmployeesCount={setEmployeesCount}
									handleClaim={handlePurchaseEmployees}
									expedition={expedition}
									activeTab={activeTab}
									loading={loading}
									setActiveTab={setActiveTab}
								/>
							);
						})()}
				</>
			);
		};

		export { ActiveExpeditionInfo };
